export default function capitalizeString(value) {
  if (typeof value !== "string") return value;
  return value.charAt(0).toUpperCase() + value.slice(1);
}
